<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs *ngIf="checkListKeyno !== '0'" [(ttSelectedId)]="selectedBgCheckListSelection">
                <tt-tab ttId="HEAD" ttLabel="checklist_head"></tt-tab>
                <tt-tab ttId="FIELDS" ttLabel="checklist_fields"></tt-tab>
            </tt-tabs>

            <div [hidden]="selectedBgCheckListSelection !== 'HEAD'">
                <ng-container *ngTemplateOutlet="basicInfo"></ng-container>
            </div>

            <div *ngIf="checkListKeyno !== '0'" [hidden]="selectedBgCheckListSelection !== 'FIELDS'">
                <tt-input ttLabel="searchtext" ttFocus="false" [(ttModel)]="searchText" ttShowClearButton></tt-input>
                <tt-button-goto ttText="checklist_create_new_checklistitem" ttGoto="checklistitem" [ttGotoParms]="{ checklistitem_keyno: '0', checklist_keyno: edit.checklist_keyno }" ttIcon="far fa-plus"></tt-button-goto>
                <tt-button ttText="checklist_checklistitem_renum" (ttClick)="renumberChanges()" [ttSpin]="renumbering" ttIcon="glyphicon glyphicon-sort-by-order"></tt-button>
            </div>
        </tt-card>

        <tt-list [hidden]="selectedBgCheckListSelection !== 'FIELDS'" [ttData]="itemsListCheckItems" [ttFilter]="searchText"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="checklist_head" ttTranslate>
                <ng-container *ngTemplateOutlet="basicInfo"></ng-container>
            </tt-card>

            <div *ngIf="checkListKeyno !== '0'">
                <div class="col-xs-12 col-md-6 p-5">
                    <tt-card ttHeading="checklist_fields" ttTranslate>
                        <tt-input ttLabel="searchtext" ttFocus="false" [(ttModel)]="searchText" ttShowClearButton></tt-input>
                        <tt-button ttText="checklist_checklistitem_renum" (ttClick)="renumberChanges()" [ttSpin]="renumbering" ttIcon="glyphicon glyphicon-sort-by-order"></tt-button>
                    </tt-card>

                    <tt-list [ttData]="itemsListCheckItems" [ttFilter]="searchText"></tt-list>
                </div>

                <tt-card class="col-xs-12 col-md-2 p-5">
                    <tt-button-goto ttText="checklist_create_new_checklistitem" ttGoto="checklistitem" [ttGotoParms]="{ checklistitem_keyno: '0', checklist_keyno: edit.checklist_keyno }" ttIcon="far fa-plus"></tt-button-goto>
                </tt-card>
            </div>
        </div>
    </div>
</tt-page>

<ng-template #basicInfo>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="checklist_keyno" [ttModel]="edit.checklist_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="checklist_name" [(ttModel)]="edit.checklist_name" ttRequired></tt-input>
        <tt-textarea ttLabel="checklist_description" [(ttModel)]="edit.checklist_description"></tt-textarea>
        <tt-checkbox ttLabel="autocreate" [(ttModel)]="edit.autocreate"></tt-checkbox>

        <div [hidden]="edit.autocreate !== '1'">
            <tt-select ttLabel="autocreate_table_name" [(ttModel)]="edit.autocreate_table_name" [ttData]="selectListAutoCreateTables" ttDataId="autocreate_table_name" ttDataName="autocreate_table_name" ttRequired></tt-select>
            <tt-select [hidden]="edit.autocreate_table_name !== 'custact'" ttLabel="activitytype" [(ttModel)]="edit.activitytype_no" [ttData]="selectListActivityTypes" ttDataId="activitytype_no" ttDataName="activitytype_name"></tt-select>
        </div>

        <tt-checkbox ttLabel="lock_to_portal_user_when_approved" [(ttModel)]="edit.lock_to_portal_user_when_approved"></tt-checkbox>
        <tt-checkbox ttLabel="checklist_paged" [(ttModel)]="edit.paged"></tt-checkbox>
        <tt-button-save ttText="checklist_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>
